import { useCallback } from 'react';
import { LegalRegionSwitcher } from '../legal-region-switcher';

import './style.scss';

type Props = {
  isShowSwitcher?: boolean;
};

export default function Nav(props: Props): JSX.Element {
  const { isShowSwitcher = true } = props;
  const onClickLogo = useCallback(() => {
    const page_name = location.pathname.replace(/(\/studio)?\//, '');
    window.Tea('pc_click_logo', {
      page_name,
    });
    window.open('https://www.lemon8-app.com/feed/foryou', '_blank');
  }, []);

  return (
    <div className="nav-container">
      <div className="nav-main">
        <div className="nav-logo" onClick={onClickLogo} />
        {isShowSwitcher && (
          <div className="nav-right">
            <LegalRegionSwitcher className="nav-lang-switcher" />
          </div>
        )}
      </div>
    </div>
  );
}
